class localStorageService { 
    setLocalStorage = (key: string, data: any) => {
        localStorage.setItem(key, JSON.stringify(data))
    }

    getLocalStorage = (key: string): []|any => {
        let result = localStorage.getItem(key)
       
        if (result == undefined || result == null || result == "") {
            return []
        }
        else{
            result = JSON.parse(result!)
            return result
        }       
    }   
}

var LocalStorageService = new localStorageService();
export {
    LocalStorageService
}
